/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { MsgTransfer, MsgUpdateParams } from './tx'
export const AminoConverter = {
  '/ibc.applications.transfer.v1.MsgTransfer': {
    aminoType: 'cosmos-sdk/MsgTransfer',
    toAmino: MsgTransfer.toAmino,
    fromAmino: MsgTransfer.fromAmino
  },
  '/ibc.applications.transfer.v1.MsgUpdateParams': {
    aminoType: 'cosmos-sdk/MsgUpdateParams',
    toAmino: MsgUpdateParams.toAmino,
    fromAmino: MsgUpdateParams.fromAmino
  }
}
